// src/App.js

import React from 'react';
import { useAuth } from './context/AuthContext';
import Login from './components/Login';
import Layout from './components/Layout'; // <-- 1. IMPORT LAYOUT
import './App.css';

function App() {
  const { currentUser } = useAuth();

  return (
    <div className="App">
      {/* 2. CHANGE THIS LINE TO RENDER LAYOUT INSTEAD OF DASHBOARD */}
      {currentUser ? <Layout /> : <Login />}
    </div>
  );
}

export default App;